<template>
  <div class="area">
    <div class="top">
      <i
        v-if="value"
        class="iconfont iconmap address-map"
        @click="mapVisible = true"
      />
      <MapModal
        v-if="mapVisible && value"
        :visible.sync="mapVisible"
        :address="value"
        :last-code="lastCode"
        :fieldkey="data.fieldkey"
        :fieldtype="data.fieldtype"
      />
      <div
        class="btn"
        @click="focusHandle"
      >
        <span
          v-if="value"
          class="name fs-black"
        >{{ value }}</span>
        <span
          v-else
          class="name"
        >{{ $t('message["855"]') }}</span>
        <i class="iconfont iconicon-test18" />
      </div>
    </div>

    <linkage
      ref="linkage"
      :default-value="routes"
      :visible.sync="visible"
      :get-data="getData"
      :search-data="searchData"
      :report-search="reportSearch"
      @confirm="changeHandle"
    />
    <cube-validator
      ref="formItem"
      v-model="data.valid"
      :model="data.fieldvalue"
      :data="data"
      :rules="data.rules"
      :messages="data.messages"
      :immediate="false"
    />
    <cube-input
      v-if="enableinput"
      v-model="data.fieldvalue.address"
      :placeholder="addressPlaceholder"
      class="detail-input border-top-1px"
      @input="handleInput"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { getArea, SearchArea as searchArea, addAreaSearchLog } from '@/services'
import Linkage from '@/components/mobile/Linkage'
import MapModal from '@/components/mobile/map/MapModal2'

export default {
  components: {
    Linkage,
    MapModal
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data () {
    /* const defaultValue = [
      {
        code: 'A',
        name: '亚洲'
      },
      {
        code: 'CHN',
        name: '中国'
      },
      {
        code: 'CHN041',
        name: '河南'
      },
      {
        code: 'CHN041001',
        name: '郑州'
      },
      {
        code: 'CHN041001081',
        name: '巩义市'
      }
    ] */
    return {
      visible: false,
      routes: [],
      mapVisible: false
    }
  },
  computed: {
    fieldAddress () {
      const { fieldvalue = {} } = this.data || {}
      return fieldvalue.address || ''
    },
    value () {
      if (this.routes.length) {
        return this.routes.map(item => item.name).join(' / ')
      }
      return ''
    },
    lastCode () {
      let len = this.routes.length
      let lastCodeItem = this.routes[len - 1]
      return lastCodeItem.code
    },
    enableinput () {
      const { fieldconfig = {} } = this.data
      const { enableinput = 1 } = fieldconfig
      return enableinput
    },
    addressPlaceholder () {
      return this.$t('message["813"]')
    }
  },
  created () {
    let { fieldvalue = {} } = this.data || {}
    let { code = {} } = fieldvalue
    this.routes = _.reduce(code, (res, item, k) => {
      let obj = {}
      obj.name = item
      obj.code = k
      res.push(obj)
      return res
    }, [])

    this.data.rules.custom = this.validateArea
  },
  methods: {
    async getData ({ level, data }) {
      const chain = await getArea()
      let params = {}
      if (data) {
        params.code = data.code
      }
      if (this.data && this.data.fieldkey) {
        params.fieldkey = this.data.fieldkey
      }
      if (Object.keys(params).length > 0) {
        chain.params(params)
      }
      return new Promise(async (resolve, reject) => {
        await chain
          .onSuccess(payload => {
            const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    async searchData ({ keyword }) {
      const chain = await searchArea()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            keyword,
            fieldkey: this.data.fieldkey
          })
          .onSuccess(payload => {
            const arr = payload.map(item => {
              return Object.keys(item).map(code => {
                return {
                  code,
                  name: item[code]
                }
              })
            })
            // const arr = Object.keys(payload).map(key => payload[key])
            resolve(arr)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    },
    focusHandle () {
      // this.visible = true
      this.$refs.linkage && this.$refs.linkage.show()
    },
    changeHandle (selected, hasChild) {
      if (!hasChild) {
        this.visible = false
      }
      this.routes = selected
      this.data.fieldvalue.code = _.reduce(selected, (res, item, k) => {
        res[item.code] = item.name
        return res
      }, {})
      this.$emit('change', this.data.fieldvalue)
      this.$refs.formItem.validate()
    },
    handleInput () {
      // this.data.fieldvalue.address = this.fieldAddress.trim()
      this.data.fieldvalue.address = this.fieldAddress
      this.$emit('change', this.data.fieldvalue)
      this.$refs.formItem.validate()
    },
    validate (cb) {
      this.$refs.formItem.validate(cb)
    },
    validateArea () {
      let { fieldname = '', fieldvalue = {}, isneeded } = this.data
      let { code = {} } = fieldvalue

      if (!isneeded) return true
      if (code && Object.values(code).length) {
        return true
      } else {
        this.data.messages.custom = this.$t('message["855"]') + fieldname
        return false
      }
    },
    async reportSearch (value) {
      const chain = await addAreaSearchLog()
      return new Promise(async (resolve, reject) => {
        await chain
          .params({
            name: value
          })
          .onSuccess(payload => {
            resolve(true)
          })
          .onNetFail(err => {
            reject(err)
          })
          .fetch()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.area ::v-deep {
  /* height: 48px;
  line-height: 48px; */
  flex: 1;
  .top {
    display: flex;
  }
  .address-map {
    padding-right: 10px;
    color: #d6d6d6;
  }
  .btn {
    display: flex;
    flex: 1;
    justify-content: space-between;
    color: #d6d6d6;
  }
  .name {
    line-height: 1;
    align-self: center;
  }

  .iconfont {
    color: #d6d6d6;
  }
  input::-webkit-input-placeholder,
  .cube-input-field::-webkit-input-placeholder {
    color: #d6d6d6;
  }
  .detail-input {
    height: 56px;
  }
}
</style>
